"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavButton;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
function NavButton(_ref) {
  let {
    children,
    onClick,
    direction
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "calendarNavButton",
    className: (0, _clsx.default)(classes.navButton, direction ? classes.navButtonLeft : classes.navButtonRight),
    type: "button",
    onClick: onClick
  }, children);
}